import TemplateView from '../../TemplateView'
import {getInstance as getWorkflowStatusFilterMenu} from "../../workflowStatus/components/statusFilter/TaskWorkflowStatusFilterMenu"
import {getInstance as getSimpleStatusFilterMenu} from "./StatusFilterMenu"
import {TaskSortBy} from '../constants'
import SortableTableHeader from '../../controls/SortableTableHeader'
import $ from 'jquery'
import StatusFilterButton from './StatusFilterButton'
import TaskSelectionLabel from '../TaskSelectionLabel'
import {changeTasksSortingAction, updateTaskTypeOfWork} from './actions'
import {getArchivedProjectIds, getShownColumnsWithOrder, getTasksSorting, thereAreTableTasks} from './selectors'
import {
    getEditableProjectIds,
    getEditableTaskIds,
    getSingleCPSelection,
    getTaskStatusFilter,
    getViewerSettings,
    isNeedToShowSelection,
} from '../common/selectors'
import {connect} from "../../redux/utils"
import {bindActionCreators} from 'redux'
import {isBTYEnabled, isESTEnabled, isTWSEnabled} from '../../features/selectors'
import {getWorkflowStatuses as getWorkflowStatusesMap} from '../../entities/selectors'
import {isAllTasksSelectedCheckboxChecked} from '../taskSelection/selectors'

class TaskTableHeader extends TemplateView {
    constructor({
        changeTasksSortingAction = () => {},
        updateTaskTypeOfWork = () => {},
    }) {
        super()

        this.actions = {
            changeTasksSortingAction,
            updateTaskTypeOfWork,
        }

        this.state = {
            isScrolling: false,
            isTWSEnabled: null,
            isBTYEnabled: null,
            isESTEnabled: null,

            sorting: {
                by: '',
                asc: false,
            },

            showSelection: false,
            allTaskSelected: false,
            selectAllDisabled: false,

            columnsOrder: [],
            taskStatusFilter: {
                allSelected: true,
                statusTypes: [],
                statusIds: []
            },
            workflowStatusesMap: {},
            singleCustomerProjectSelection: {},
        }

        this.onStatePropertyChanged('singleCustomerProjectSelection', singleCustomerProjectSelection => {
            if (singleCustomerProjectSelection.customerId && !singleCustomerProjectSelection.projectId) {
                this._toggleCptSortButtons(false, true)
            } else if (singleCustomerProjectSelection.customerId && singleCustomerProjectSelection.projectId) {
                this._toggleCptSortButtons(false, false)
            } else {
                this._toggleCptSortButtons(true, true)
            }
        })

        this.onStatePropertyChanged('isScrolling', (isScrolling) => {
            this.$el.toggleClass('scrolling', isScrolling)
        })

        this.onStatePropertyChanged('sorting', (sorting) => {
            this.setSortHeader(sorting.by, sorting.asc)
        })

        this.onStatePropertyChanged('columnsOrder', (columnsOrder) => {
            for (let column of Object.values(this.columnsMap)) {
                column.hide()
            }

            for (let i = 0; i < columnsOrder.length; ++i) {
                const columnKey = columnsOrder[i]
                this.columnsMap[columnKey].show().css('display', 'flex')
                this.columnsMap[columnKey].css('order', i.toString())
            }
        })

        this.onStatePropertyChanged('isTWSEnabled', (isTWSEnabled) => {
            // rewrite click action on status header
            $(this.statusHeader).off('click')
            $(this.statusHeader).on('click', () => {
                this.actions.changeTasksSortingAction({
                    by: isTWSEnabled ? TaskSortBy.WORKFLOW_STATUS : TaskSortBy.STATUS,
                    asc: this.statusHeader.isAsc(),
                })
            })

            this._updateTaskStatusFilter(isTWSEnabled)
        })

        this.onStatePropertyChanged('isBTYEnabled', (isBTYEnabled) => {
            this.typeOfWorkHeader.toggle(isBTYEnabled)
        })

        this.onStatePropertyChanged('isESTEnabled', (isESTEnabled) => {
            this.estimateHeader.toggle(isESTEnabled)
        })

        this.onAnyStatePropertyChanged(['taskStatusFilter', 'workflowStatusesMap'], (state) => {
            this.statusFilterButton.setState({
                filter: state.taskStatusFilter,
                workflowStatusesMap: state.workflowStatusesMap,
            })
        })

        this.onAnyStatePropertyChanged(['allTaskSelected', 'showSelection', 'selectAllDisabled'], () => {
            this._updateAllTasksSelection()
        })
    }

    templateHtml() {
        return "<table class='headerRowTable' cellpadding='0' cellspacing='0'>" +
               "  <tr>" +
               "    <td class='selection'></td>" +
               "    <td class='names'>" +
               "      <div class='headerCellWrapper'>" +
               "        <div class='tipPlaceholderContainer'><span class='tipPlaceholder'></span></div>" +
               "        <span class='customerNameHeader'></span>" +
               "        <span class='shortSeparator customerNameSeparator'>&nbsp;</span>" +
               "        <span class='projectNameHeader'></span>" +
               "        <span class='shortSeparator projectNameSeparator'>&nbsp;</span>" +
               "        <span class='taskNameHeader'></span>" +
               "      </div>" +
               "    </td>" +
               "    <td class='status'>" +
               "      <div class='headerCellWrapper'>" +
               "        <span class='statusHeader'></span>" +
               "        <span class='statusFilterButtonContainer'></span>" +
               "      </div>" +
               "    </td>" +
               "    <td class='typeOfWork'>" +
               "      <div class='headerCellWrapper'><span class='typeOfWorkHeader'></span></div>" +
               "    </td>" +
               "    <td class='estimate'>" +
               "      <div class='headerCellWrapper'><span class='estimateHeader'></span></div>" +
               "    </td>" +
               "    <td class='spentTime'>" +
               "      <div class='headerCellWrapper'><span class='spentTimeHeader'></span></div>" +
               "    </td>" +
               "    <td class='deadline'>" +
               "      <div class='headerCellWrapper'><span class='deadlineHeader'></span></div>" +
               "    </td>" +
               "    <td class='lastTrackingDate'>" +
               "      <div class='headerCellWrapper'><span class='lastTrackingDateHeader'></span></div>" +
               "    </td>" +
               "    <td class='creationDate'>" +
               "      <div class='headerCellWrapper'><span class='creationDateHeader'></span></div>" +
               "    </td>" +
               "  </tr>" +
               "</table>"
    }

    afterRender() {
        this.$allTaskSelection = this.find(".selection")

        this.sortingHeaders = {}
        // Persistence block
        this.customerNameHeader = new SortableTableHeader(this.find(".customerNameHeader"), false, true, "common.Customer").init()
        this.customerNameSeparator = this.find(".customerNameSeparator")
        this.sortingHeaders[TaskSortBy.CUSTOMER] = this.customerNameHeader

        this.projectNameHeader = new SortableTableHeader(this.find(".projectNameHeader"), false, true, "common.Project").init()
        this.projectNameSeparator = this.find(".projectNameSeparator")
        this.sortingHeaders[TaskSortBy.PROJECT] = this.projectNameHeader

        this.taskNameHeader = new SortableTableHeader(this.find(".taskNameHeader"), false, true, "common.Task").init()
        this.sortingHeaders[TaskSortBy.TASK] = this.taskNameHeader

        // this header sorting depends from feature
        this.statusHeader = new SortableTableHeader(this.find(".statusHeader"), false, true, "task.list.status").init()
        this.sortingHeaders[TaskSortBy.STATUS] = this.statusHeader
        this.sortingHeaders[TaskSortBy.WORKFLOW_STATUS] = this.statusHeader

        this.typeOfWorkHeader = new SortableTableHeader(this.find(" .typeOfWorkHeader"), false, true, "task.list.type_of_work").init()
        this.sortingHeaders[TaskSortBy.TYPE_OF_WORK] = this.typeOfWorkHeader

        this.estimateHeader = new SortableTableHeader(this.find(".estimateHeader"), false, true, "task.list.estimate").init()
        this.sortingHeaders[TaskSortBy.ESTIMATE] = this.estimateHeader

        this.deadlineHeader = new SortableTableHeader(this.find(".deadlineHeader"), false, true, "task.list.deadline").init()
        this.sortingHeaders[TaskSortBy.DEADLINE] = this.deadlineHeader

        this.spentTimeHeader = new SortableTableHeader(this.find(".spentTimeHeader"), false, true, "task.list.spent_time").init()
        this.sortingHeaders[TaskSortBy.SPENT_TIME] = this.spentTimeHeader

        this.lastTrackingDateHeader = new SortableTableHeader(this.find(".lastTrackingDateHeader"), false, true, "task.list.last_tracking_date").init()
        this.sortingHeaders[TaskSortBy.LAST_TRACKING_DATE] = this.lastTrackingDateHeader

        this.creationDateHeader = new SortableTableHeader(this.find(".creationDateHeader"), false, true, "task.list.creation_date").init()
        this.sortingHeaders[TaskSortBy.CREATION_DATE] = this.creationDateHeader

        this.columnsMap = {
            [TaskSortBy.ESTIMATE]: this.find("td.estimate"),
            [TaskSortBy.DEADLINE]: this.find("td.deadline"),
            [TaskSortBy.CREATION_DATE]: this.find("td.creationDate"),
            [TaskSortBy.LAST_TRACKING_DATE]: this.find("td.lastTrackingDate"),
            [TaskSortBy.SPENT_TIME]: this.find("td.spentTime"),
            [TaskSortBy.TYPE_OF_WORK]: this.find("td.typeOfWork"),
        }

        for (let sortingHeaderKey of Object.keys(this.sortingHeaders)) {
            let sortingHeader = this.sortingHeaders[sortingHeaderKey]
            $(sortingHeader).off('click')
            $(sortingHeader).on('click', () => {
                this.actions.changeTasksSortingAction({
                    by: sortingHeaderKey,
                    asc: sortingHeader.isAsc(),
                })
            })
        }
    }

    setSortHeader(by, asc) {
        const byWorkflowStatus = by === TaskSortBy.WORKFLOW_STATUS
        for (let key of Object.keys(this.sortingHeaders)) {
            let sortingHeader = this.sortingHeaders[key]
            if (byWorkflowStatus && key !== TaskSortBy.STATUS
                || !byWorkflowStatus && key === TaskSortBy.STATUS
                || key !== TaskSortBy.STATUS && key !== TaskSortBy.WORKFLOW_STATUS
            ) {
                if (key === by) {
                    sortingHeader.setActive(true)
                    sortingHeader.setAsc(asc)
                }
                else {
                    sortingHeader.setActive(false)
                }
            }
        }
    }

    _toggleCptSortButtons(showCustomer, showProject) {
        this.customerNameHeader.toggle(showCustomer)
        this.customerNameSeparator.toggle(showCustomer)
        this.projectNameHeader.toggle(showProject)
        this.projectNameSeparator.toggle(showProject)

        if (!showCustomer && this.state.sorting.by === TaskSortBy.CUSTOMER) {
            if (showProject) {
                this.setSortHeader(TaskSortBy.PROJECT, this.state.sorting.asc)
            } else {
                this.setSortHeader(TaskSortBy.TASK, this.state.sorting.asc)
            }
        } else if (!showProject && this.state.sorting.by === TaskSortBy.PROJECT) {
            this.setSortHeader(TaskSortBy.TASK, this.state.sorting.asc)
        } else {
            this.setSortHeader(this.state.sorting.by, this.state.sorting.asc)
        }
    }

    _updateAllTasksSelection() {
        this.$allTaskSelection.empty()
        if (this.state.showSelection) {
            this.$allTaskSelection.show()
            this.allTaskSelectionLabel = new TaskSelectionLabel(this.$allTaskSelection, true).init()
            this.allTaskSelectionLabel.setSelection(this.state.allTaskSelected)
            this.allTaskSelectionLabel.setDisabled(this.state.selectAllDisabled)
            this.allTaskSelectionLabel.on("change", (e, isAllSelected) => {
                // this.actions.changeSelectAllTasks(isAllSelected)

                $(document).trigger("taskManagement_taskTable_selectAllChange", isAllSelected)
            })
        }
        else {
            this.$allTaskSelection.hide()
        }
    }

    _updateTaskStatusFilter(isTWSEnabled) {
        const $filterContainer = this.find(".status .statusFilterButtonContainer")
        $filterContainer.empty()

        if (isTWSEnabled) {
            this.statusFilterButton = new StatusFilterButton({
                getStatusMenu: () => getWorkflowStatusFilterMenu(),
            }).init($filterContainer)
        } else {
            this.statusFilterButton = new StatusFilterButton({
                getStatusMenu: () => getSimpleStatusFilterMenu(),
            }).init($filterContainer)
        }
    }
}

export default connect(
    (state) => ({
        sorting: getTasksSorting(state),
        archivedProjectIds: getArchivedProjectIds(state),
        viewerSettings: getViewerSettings(state),
        editableTaskIds: getEditableTaskIds(state),
        editableProjectIds: getEditableProjectIds(state),
        showSelection: isNeedToShowSelection(state),
        isTWSEnabled: isTWSEnabled(state),
        isBTYEnabled: isBTYEnabled(state),
        isESTEnabled: isESTEnabled(state),
        columnsOrder: getShownColumnsWithOrder(state),
        taskStatusFilter: getTaskStatusFilter(state),
        workflowStatusesMap: getWorkflowStatusesMap(state),
        singleCustomerProjectSelection: getSingleCPSelection(state),
        allTaskSelected: isAllTasksSelectedCheckboxChecked(state),
        selectAllDisabled: !thereAreTableTasks(state),
    }),
    (dispatch) => ({
        changeTasksSortingAction: bindActionCreators(changeTasksSortingAction, dispatch),
        updateTaskTypeOfWork: bindActionCreators(updateTaskTypeOfWork, dispatch),
    })
)(TaskTableHeader)


// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/TaskTableHeader.js